import { render, staticRenderFns } from "./TagView.vue?vue&type=template&id=e92b00a0&scoped=true"
import script from "./TagView.vue?vue&type=script&lang=js"
export * from "./TagView.vue?vue&type=script&lang=js"
import style0 from "./TagView.vue?vue&type=style&index=0&id=e92b00a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92b00a0",
  null
  
)

export default component.exports